import { render, staticRenderFns } from "./LockScreen.vue?vue&type=template&id=58005236&scoped=true"
import script from "./LockScreen.vue?vue&type=script&lang=js"
export * from "./LockScreen.vue?vue&type=script&lang=js"
import style0 from "./LockScreen.vue?vue&type=style&index=0&id=58005236&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58005236",
  null
  
)

export default component.exports